import { render, staticRenderFns } from "./PianificazioneTabella.vue?vue&type=template&id=b0ce167a&scoped=true&"
import script from "./PianificazioneTabella.vue?vue&type=script&lang=js&"
export * from "./PianificazioneTabella.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ce167a",
  null
  
)

export default component.exports